// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.productIntro_mainContainer {
  background-color: #1d1a36;
  padding-left: 20px;
  padding-right: 20px;
  margin-bottom: 30px;
}
.productIntro_productName {
  margin-top: 3vw;
}
.productIntro_intromainRow {
  margin-top: 8.0321285141vh;
  margin-bottom: 8.0321285141vh;
}
@media (max-width: 1200px) {
  .productIntro_intromainRow {
    margin-top: 0 !important;
  }
}
.productIntro_loading {
  display: flex;
  justify-content: left;
  margin: 4rem 0;
  width: 100%;
  border: 1px solid red;
}
.productIntro_loading-image {
  border: 1px solid green;
  z-index: 2;
  height: 10vh;
}
.productIntro_fyndrProductImgDiv {
  display: flex;
  justify-content: center;
}
.productIntro_fyndrProductImg {
  width: 14.9739583333vw !important;
  margin-top: 1.953125vw;
  height: auto;
}
@media (max-width: 992px) {
  .productIntro_fyndrProductImg {
    width: 41.974vw !important;
  }
}
@media (max-width: 576px) {
  .productIntro_fyndrProductImg {
    width: 52.974vw !important;
  }
}
.productIntro_nuodataProductImg {
  width: 14.9739583333vw !important;
  margin-top: 1.953125vw;
  height: auto;
}
@media (max-width: 992px) {
  .productIntro_nuodataProductImg {
    width: 25vw !important;
  }
}
@media (max-width: 576px) {
  .productIntro_nuodataProductImg {
    width: 40vw !important;
  }
}
.productIntro_aboutfyndr {
  color: var(--white, #fff);
  margin-top: 2.5140562249vh;
  font-size: 4.016064257vh;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.productIntro_aboutNuoData {
  color: var(--white, #fff);
  text-align: center;
  margin-top: 2.5140562249vh;
  font-size: 4.016064257vh;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.productIntro_aboutfyndrIntro {
  color: var(--white, #fff);
  text-align: center;
  margin-top: 0.75rem;
  font-size: 2.8vh;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  min-height: 13vh;
}
@media (max-width: 1024px) {
  .productIntro_aboutfyndrIntro {
    font-size: 1.5rem;
  }
}
@media (max-width: 575px) {
  .productIntro_aboutfyndrIntro {
    font-size: 1rem;
  }
}
.productIntro_aboutfyndrIntro1 {
  color: var(--white, #fff);
  text-align: center;
  font-size: 2.1vh;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}
.productIntro_fyndrWebImg {
  margin-top: 0.938rem;
}
.productIntro_nuodataWebImg {
  margin-top: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/Components/ProductIntroduction/productIntroduction.scss"],"names":[],"mappings":"AACE;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;AAAJ;AAEE;EACE,eAAA;AAAJ;AAEE;EACE,0BAAA;EACA,6BAAA;AAAJ;AACI;EAHF;IAII,wBAAA;EAEJ;AACF;AACE;EACE,aAAA;EACA,qBAAA;EACA,cAAA;EACA,WAAA;EACA,qBAAA;AACJ;AAEE;EACE,uBAAA;EACA,UAAA;EACA,YAAA;AAAJ;AAEE;EACE,aAAA;EACA,uBAAA;AAAJ;AAGE;EACE,iCAAA;EACA,sBAAA;EACA,YAAA;AADJ;AAEI;EAJF;IAKI,0BAAA;EACJ;AACF;AAAI;EAPF;IAQI,0BAAA;EAGJ;AACF;AADE;EACE,iCAAA;EACA,sBAAA;EACA,YAAA;AAGJ;AAFI;EAJF;IAKI,sBAAA;EAKJ;AACF;AAHI;EARF;IASI,sBAAA;EAMJ;AACF;AAHE;EACE,yBAAA;EACA,0BAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAKJ;AAHE;EACE,yBAAA;EACA,kBAAA;EACA,0BAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAKJ;AAFE;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAIJ;AAHI;EATF;IAUI,iBAAA;EAMJ;AACF;AALI;EAZF;IAaI,eAAA;EAQJ;AACF;AALE;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAOJ;AAJE;EACE,oBAAA;AAMJ;AAHE;EACE,gBAAA;AAKJ","sourcesContent":[".productIntro {\n  &_mainContainer {\n    background-color: #1d1a36;\n    padding-left: 20px;\n    padding-right: 20px;\n    margin-bottom: 30px;\n  }\n  &_productName {\n    margin-top: 3vw;\n  }\n  &_intromainRow {\n    margin-top: 8.032128514056225vh;\n    margin-bottom: 8.032128514056225vh;\n    @media (max-width:1200px){\n      margin-top: 0 !important;\n    }\n  }\n\n  &_loading {\n    display: flex;\n    justify-content: left;\n    margin: 4rem 0;\n    width: 100%;\n    border: 1px solid red;\n  }\n\n  &_loading-image {\n    border: 1px solid green;\n    z-index: 2;\n    height: 10vh;\n  }\n  &_fyndrProductImgDiv {\n    display: flex;\n    justify-content: center;\n  }\n\n  &_fyndrProductImg {\n    width: 14.973958333333334vw !important;\n    margin-top: 1.953125vw;\n    height: auto;\n    @media (max-width: 992px) {\n      width: 41.974vw !important;\n    }\n    @media (max-width: 576px) {\n      width: 52.974vw !important;\n    }\n  }\n  &_nuodataProductImg {\n    width: 14.973958333333334vw !important;\n    margin-top: 1.953125vw;\n    height: auto;\n    @media (max-width: 992px) {\n      width: 25vw !important;\n    }\n\n    @media (max-width: 576px) {\n      width: 40vw !important;\n    }\n  }\n\n  &_aboutfyndr {\n    color: var(--white, #fff);\n    margin-top: 2.5140562248995986vh;\n    font-size: 4.016064257028113vh;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n  }\n  &_aboutNuoData {\n    color: var(--white, #fff);\n    text-align: center;\n    margin-top: 2.5140562248995986vh;\n    font-size: 4.016064257028113vh;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n  }\n\n  &_aboutfyndrIntro {\n    color: var(--white, #fff);\n    text-align: center;\n    margin-top: 0.75rem;\n    font-size: 2.8vh;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%;\n    min-height: 13vh;\n    @media (max-width: 1024px) {\n      font-size: 1.5rem;\n    }\n    @media (max-width: 575px) {\n      font-size: 1rem;\n    }\n  }\n\n  &_aboutfyndrIntro1 {\n    color: var(--white, #fff);\n    text-align: center;\n    font-size: 2.1vh;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%;\n  }\n\n  &_fyndrWebImg {\n    margin-top: 0.938rem;\n  }\n\n  &_nuodataWebImg {\n    margin-top: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
